import TabNav from "common/components/TabNav"
import { TFunction } from "i18next"
import { nanoid } from "nanoid"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { TAB_DOCUMENTOS_RECIBIDOS } from "../../constants"
import PresupuestosEnviados from "./PresupuestosEnviados"
import PresupuestosRecibidos from "./PresupuestosRecibidos"

const TABS = (t: TFunction) => [
  {
    key: nanoid(),
    header: `${t("crear.presupuesto.saleLabel")}`,
    component: PresupuestosEnviados,
    id: 0,
  },
  {
    key: TAB_DOCUMENTOS_RECIBIDOS,
    header: `${t("crear.presupuesto.buyLabel")}`,
    component: PresupuestosRecibidos,
    id: 1,
  },
]

const Presupuestos = () => {
  const { t } = useTranslation()
  const [tabSelected, setTabSelected] = useState(0)

  return (
    <div className='tw-bg-white tw-rounded-xl tw-min-w-fit tw-shadow !tw-h-full tw-overflow-hidden'>
      <div className='tw-py-4 tw-px-8 mobile:tw-flex tw-justify-between tw-flex-col tw-items-start sm:tw-items-center sm:tw-flex-row tw-hidden'>
        <TabNav
          tabs={TABS(t)}
          active={tabSelected}
          setActive={setTabSelected}
        />
      </div>
      {TABS(t).map((tab) => (
        <>{tab.id === tabSelected && <tab.component />}</>
      ))}
    </div>
  )
}

export default Presupuestos
